import { useUnit } from 'effector-react';
import $$api from 'models/api';
import $$dropdowns from 'models/dropdowns';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';

import DocumentListItemUpload from './DocumentListItemUpload';

import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import { Button, Frame, H1 } from 'components/StyledTemplates/StyledTemplates';

import DocumentsService from 'services/DocumentsService';
import RemainingStepsService from 'services/RemainingStepsService';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

const SecureButton = () => {
    const { t } = useResources();

    const { close } = useModal('SECURE_MODAL');

    const ep = useUnit($$ep.stores.$epQInstance);
    const documents = useUnit($global.map((state) => state?.temp?.documents_in_progress?.documents || []));
    const [locationDescription, setLocationDescription] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLocationDescription(ep?.location_description || '');
    }, [ep?.location_description]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setLocationDescription(event.target.value || '');
    };

    if (!ep) {
        return null;
    }

    const saveAndContinue = async () => {
        try {
            setLoading(true);
            await $$api.qInstances.setLocationFx({
                id: ep.questionnaire_instance_id,
                location: locationDescription.trim(),
            });
            await RemainingStepsService.completeStep('signed');
            $$dropdowns.open('REMAINING_ACTIONS');
            await $$api.participants.getCommunityFx(undefined);
            close();
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <PopUpWrapper name="SECURE_MODAL" size="lg" whiteCross>
            <CommunityTab
                title={<H1 extra="font-size: 25px !important; margin: 0 !important;">{t('EPCard.secureHeader')}</H1>}
            >
                <Frame extra="width: 100%; display: block;">
                    <h5 className="mt-3">
                        <span className="required-mark-start" />
                        {t('EPCard.secureModalSubheader')}
                    </h5>
                    <Form noValidate>
                        <Form.Row>
                            <Form.Group as={Col} controlId="location">
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    required
                                    value={locationDescription}
                                    onChange={handleChange}
                                    data-hj-allow
                                    placeholder={t('EPCard.secureTextareaPlaceholder')}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Button
                            data-qaid="continue_button"
                            variant="primary px-5 ml-2"
                            onClick={saveAndContinue}
                            disabled={!locationDescription.trim() || loading}
                        >
                            {t('EPCard.continue')}
                        </Button>
                    </Form>
                    <h5 className="mt-4">{t('EPCard.uploadYourDocumentsBelow')}</h5>
                    <ul style={{ paddingInlineStart: '15px' }}>
                        <li>{t('EPCard.secureListItem1')}</li>
                        <li>{t('EPCard.secureListItem2')}</li>
                    </ul>
                    {documents
                        .filter((d) => DocumentsService.isSignable(d))
                        .map((document) => {
                            return (
                                <DocumentListItemUpload
                                    key={document.document_id}
                                    document={document}
                                    forceUpdateParent={() => {}}
                                />
                            );
                        })}
                </Frame>
            </CommunityTab>
        </PopUpWrapper>
    );
};

export default SecureButton;
